import { Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';

import { style } from '../../../components/pdf/fontstyles';




        
const departmentalCertificate = ({ result }) => (
  
              <View size="A4" style={style.page}> 
                <Text style={[style.title, style.ArialBlack]}>DEPARTMENTAL ENQUIRY CERTIFICATE</Text>
         
                <Text style={[style.paragraph, { marginTop: 10 }]}>Name of the office: <Text style={style.ArialBold}>{result.institutionName}</Text>  </Text>
               
                <Text style={[style.paragraph, { marginTop: 10 }]}>
                This is to certify that no departmental enquiry is either pending or proposed to be held against {result.employeeName}, {result.designation}</Text>



          
              
                <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 40 }}>
                <Text>Place:  {result.placeOfRetirement}</Text>
                <Text style={[ style.ArialItalic,{ fontSize: 8 },{marginRight :50}]}>Head of Office</Text>
              </View>

              <Text style={{ marginTop: 5 }}>Date:</Text>

           </View>

);

export default departmentalCertificate;